import React from 'react';

function AcaoModal({ show, onClose, onSubmit, form, handleChange, programas = [], title = 'CADASTRO DE AÇÃO' }) {
  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-lightning me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label">Programa *</label>
                <select className="form-select form-select-sm" name="idPrograma" value={form.idPrograma} onChange={handleChange} required>
                  <option value="">Selecione...</option>
                  {programas.map(p => (
                    <option key={p.id} value={p.id}>{p.descricao}</option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                {/* Código removido conforme solicitado */}
              </div>
              <div className="mb-3">
                <label className="form-label">Descrição *</label>
                <input type="text" className="form-control form-control-sm" name="descricao" value={form.descricao} onChange={handleChange} required />
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success btn-sm">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AcaoModal;
